import { ReactNode } from "react";
import BackButton from "../../../../../../components/common/BackButton";

const TicketDetailsHeader = ({ children }: { children?: ReactNode }) => {
  return (
    <div className="flex justify-between items-center p-5 border border-extra-light bg-white rounded-lg mb-4 sticky top-[79px] z-50">
      <BackButton />
      {children}
    </div>
  );
};

export default TicketDetailsHeader;
